export default __webpack_public_path__ + "static/media/001-credit card.72283bb4.svg";